import { render, staticRenderFns } from "./CharpterOne.vue?vue&type=template&id=bb97d0d2&scoped=true&"
import script from "./CharpterOne.vue?vue&type=script&lang=js&"
export * from "./CharpterOne.vue?vue&type=script&lang=js&"
import style0 from "./CharpterOne.vue?vue&type=style&index=0&id=bb97d0d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb97d0d2",
  null
  
)

export default component.exports